export const nestedRetailerManagementContent = {
    id: "retailer-management",
    menuItems: [
        {name: "All Retailers", url: "/retailerService"},
        {name: "Missing Retailers", url: "/missingRetailers"}]
}

export const nestedRetailerConfigurationsContent = {
    id: "configurations-retailers",
    menuItems: [
        {name: "Auto QC Alerts", url: "/autoQcAlerts"},
        {name: "Calculated Sales Amount", url: "/calculatedSalesAmountRetailers"},
        {name: "Check Digit", url: "/checkDigitRetailers"},
        {name: "Fresh Retailers", url: '/freshRetailers'},
        {name: "Implied Decimal", url: "/impliedDecimalRetailers"},
        {name: "Ingestion Paused", url: "/ingestionPausedRetailers"},
        {name: "Items Extract", url: "/itemsExtract"},
        {name: "Minimum Days of Sales", url: "/minimumDaysOfSales"},
        {name: "Missing Data Exclusions", url: "/missingDataRetailerExclusions"},
        {name: "Priority: Store Insights", url: "/priorityRetailers/storeInsights"},
        {name: "Receipt Lag", url: "/receiptLag"},
        {name: "Skip Cleanse Rules", url: "/skipCleanseRules"},
        {name: "Skip Daily Fill", url: "/skipDailyFill"},
        {name: "Skip Fill", url: "/skipFillRetailers"},
        {name: "Store Insights", url: "/storeInsightsIgnoredRetailers"},
        {name: "Transactional", url: "/transactionalRetailers"},
        {name: "Transactional Multi File", url: "/transactionalMultiFile"},
        {name: "Translation Retailers", url: '/translationRetailers'},
    ]
}

export const nestedStoreContent = {
    id: "configurations-stores",
    menuItems: [
        {name: "Banner", url: "/configurations/store/banner"},
        {name: "Missing Data Exclusions", url: "/configurations/store/missingDataExclusions"},
        {name: "Skip", url: "/configurations/store/skip"},
        {name: "Store Closures", url: "/storeClosures"},
        {name: "Store Participation", url: "/storeParticipation"},
        {name: "Supplemental Stores", url: "/supplementalStoreConfig"}
    ]
}

export const nestedOutliersContent = {
    id: 'alerts-outliers',
    menuItems: [
        {name: "Record Count", url: "/alerts/outliers/records"},
        {name: "Sales Amount", url: "/alerts/outliers/salesAmount"},
        {name: "Unit", url: "/alerts/outliers/salesUnits"}
    ]
}

export const nestedMarketContent = {
    id: 'market-mappings',
    menuItems: [
        {name: "All Markets", url: "/marketService"},
        {name: "Ops Market Service", url: "/marketServiceTwo"},
    ]
}

export const nestedGeographyContent = {
    id: 'geography-mappings',
    menuItems: [
        {name: "Geography Census", url: "/geographyCensus"},
        {name: "Geography Hierarchy", url: "/geographyHierarchy"},
        {name: "Geography Parentage", url: "/geographyParentage"},
        {name: "Geography Store Mapping", url: "/geographyStoreMapping"}
    ]
}

export const nestedProduceServiceContent={
    id: 'produce-service-mappings',
    menuItems: [
        {name: "Extract Cleanse Sales To Puc", url: "/extractCleanseSalesToPuc"},
        {name: "IFPS Service", url: "/ifpsService"},
        {name: "Retailer Produce Item File Override", url: "/retailerProduceItemFileOverrides"},
        {name: "Standardized Unit of Measure", url: "/standardizedUnitOfMeasure"}
    ]
}

export const nestedProjectionsContent = {
    id: 'projections-mappings',
    menuItems: [
        {name: "FIPS", url: "/fips"},
        {name: "Projection Extract", url: "/projectionsExtract"},
        {name: "Projection Factors", url: "/projectionFactors"},
        {name: "Projection Maintenance", url: "/projectionMaintenance"},
        {name: "Projection Uploads", url: "/projectionUploads"},
        {name: "Spotlight: Projections", url: "/projectionsSpotlight"},
    ]
}
